import { DB_ORG } from "@/constants/db";
import { useUserStore } from "@/stores/user-store";
import { normalizeStringForComparison } from "@/utils/transforms";
import { Select } from "antd";
import { type FC } from "react";

interface QASubmissionDraftSelectProps {
	isLoading: boolean;
	selectedFormMode: string;
	onModeChange: (mode: string, isQAForm: boolean, isDraft: boolean) => void;
}

const QASubmissionDraftSelect: FC<QASubmissionDraftSelectProps> = ({
	isLoading,
	selectedFormMode,
	onModeChange,
}) => {
	const user = useUserStore((state) => state.user);

	const handleChange = (value: string) => {
		onModeChange(value, value === "qa", value === "drafts");
	};

	let options = [
		{ value: "submitted", label: "Submitted" },
		{ value: "qa", label: "QA Submissions" },
		{ value: "drafts", label: "Drafts" },
	];

	// For organization 28, add approval workflow options
	if (user?.organization?.id === 28) {
		options = [
			{ value: "pending_approval", label: "Need Approval" },
			{ value: "approved", label: "Approved" },
			{ value: "qa", label: "QA Submissions" },
			{ value: "drafts", label: "Drafts" },
		];
	} else {
		// remove qa submissions option if not cushman wakefield
		if (
			normalizeStringForComparison(
				user?.organization?.external_firebase_id! || "",
			) === normalizeStringForComparison(DB_ORG?.CUSHMANWAKEFIELD)
		) {
			options = options.filter((option) => option.label !== "QA Submissions");
		}
	}

	// Convert old values to new format for display
	const getDisplayValue = (mode: string) => {
		if (mode === "0") return "submitted";
		if (mode === "1") return "qa";
		if (mode === "2") return "drafts";
		return mode || options[0]?.value;
	};

	return (
		<Select
			style={{ width: 200 }}
			onChange={handleChange}
			value={getDisplayValue(selectedFormMode)}
			options={options}
			placeholder={isLoading ? "Loading Forms..." : "Select a form"}
			disabled={isLoading}
		/>
	);
};

export { QASubmissionDraftSelect };
